import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add Role data
export const addRole=async (formData)=>{
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/user/app/v1/create-role`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log({ error })
      throw error
    }
  }

// update ROle
export const updateRole = async (ROWID,data) => {
  console.log({ data })
  // const ROWID = data.ROWID
  console.log("first",ROWID)
  console.log("data",data)
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/user/app/v1/update-role/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// delete Role data
export const deleteRole= async (ROWID) => {
    console.log({ ROWID })
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.delete(`${baseUrl}cleaningappfunctions/user/app/v1/delete-role/${ROWID}`, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log("Error is - ", error)
      throw error
    }
  }
